"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgRoomService = function SvgRoomService(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.532 11.461c0 .912-.2 2.104-2.134 2.104-1.933 0-2.882-1.844-2.882-2.104M6.339 5.318c.637-.208.955-.45.955-.725.367.467 1.297 1.087 3.98.725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04 9.7c-.92-.931-1.38-1.716-1.38-2.356 0-.639.352-.793 1.057-.463-.397-3.046.705-4.569 3.308-4.569 2.603 0 3.942.963 4.017 2.888-.165-.158-.425-.158-.78 0 .045.407.045.968 0 1.681 1.045-.246 1.39.097 1.036 1.027-.533 1.395-1.87 3.91-4.252 3.91-1.114-.066-2.116-.771-3.007-2.116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.511 13.34v2.717c-.062.897-.343 1.345-.898 1.345-.832 0-1.93-1.345-3.109-1.345a797.404 797.404 0 0 0 0 4.456H3.51v-5.447c0-.9.36-1.623 1.082-2.165.72-.543 1.634-1.016 2.74-1.418.533 3.049 1.113 4.574 1.741 4.574.628 0 1.3-1.525 2.017-4.574 1.993.426 3.732 1.372 5.217 2.836a188.74 188.74 0 0 1 0-1.878M14.5 11.5h7V10a3.5 3.5 0 0 0-7 0v1.5zm-1.5 0h9.919"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgRoomService);
var _default = exports["default"] = Memo;